<template>
    <div class="refresh-api-key">
        <h4 class="td-h4">Are you sure you want refresh the api key secret?</h4>
        <p style="margin-top: 15px;"><strong>Name:</strong> {{ model.name }}</p>
        <p style="margin-top: 10px;"><strong>Api Key:</strong> {{ model.apiKey }}</p>
        <br /><br /><br />
        <div style="margin-top: 25px;" class="actions">
            <button class="danger td-btn" title="Yes - Refresh Secret" @click.prevent="refreshApiKey">Yes - Refresh Secret</button>
        </div>
    </div>
</template>

<script>
    import script from './RefreshApiKey';
    export default script;
</script>

<style lang="less">
    @import "./RefreshApiKey.less";
</style>